import { useState, FC, useEffect } from "react";
import { mergeClassNames } from "../../../../helpers";
import "./Switch.css";
import { Styled } from "../../types";

type SwitchAtomProps = Styled & {
  name: string;
  checked?: boolean;
  disabled?: boolean;
  disable?: boolean;
  onChange?: (value: boolean) => void;
};

export const SwitchAtom: FC<React.PropsWithChildren<SwitchAtomProps>> = ({
  name,
  checked,
  onChange,
  className,
  disabled,
  disable,
}) => {
  const [enabled, setEnabled] = useState(checked ?? false);

  const handleChange = (value: boolean) => {
    setEnabled(value);
    if (onChange) onChange(value);
  };

  useEffect(() => {
    setEnabled(checked ?? false);
  }, [checked]);

  return (
    <input
      name={name}
      id={name}
      value={`${enabled}`}
      checked={enabled}
      disabled={disabled || disable}
      type="checkbox"
      className={mergeClassNames(
        "vviinn-switch",
        className ?? "",
        enabled
          ? "text-black dark:border-stone-700 hover:dark:border-stone-700"
          : "bg-stone-200 dark:bg-stone-600",
        "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-stone-500 focus:ring-offset-2 disabled:cursor-not-allowed",
        disabled || disable ? " bg-stone-300 opacity-40" : "",
        enabled && disabled ? "bg-stone-600" : "",
      )}
      onChange={(ev) => handleChange(ev.target.checked)}
    />
  );
};
